module.exports = __webpack_public_path__ + "static/media/bat.19809a23.svg";